import { z } from "zod";

// Create a custom Zod transformer for Firestore Timestamps
const firestoreTimestampSchema = z
  .object({
    _seconds: z.number(),
    _nanoseconds: z.number(),
  })
  .transform((timestamp) => new Date(timestamp._seconds * 1000));

export const TimestampSchema = z
  .union([
    z.date(),
    z
      .string()
      .datetime()
      .transform((str) => new Date(str)),
    firestoreTimestampSchema,
  ])
  .transform((value) => {
    // Ensure we always return a Date object
    if (value instanceof Date) {
      return value;
    }
    return new Date(value);
  });

// Firebase auto-generated document IDs are exactly 20 characters
// and contain alphanumeric characters plus hyphens and underscores
export const BaseIdSchema = z
  .string()
  .min(20, "ID must be at least 20 characters")
  .max(28, "ID must be at most 28 characters")
  .regex(
    /^[a-zA-Z0-9_-]+$/,
    "ID must contain only alphanumeric characters, hyphens, and underscores"
  );
export function validateBaseId(data: unknown): string {
  return BaseIdSchema.parse(data);
}
